import { render, staticRenderFns } from "./region-grid.vue?vue&type=template&id=5527abf8"
import script from "./region-grid.vue?vue&type=script&lang=js"
export * from "./region-grid.vue?vue&type=script&lang=js"
import style0 from "./region-grid.vue?vue&type=style&index=0&id=5527abf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports